import KB from '@kb/global-context';
import { useTranslation } from '@kb/i18n';
import { IconSymbol } from '@ocp/button';
import eventBus, { EventTypes } from '@ocp/event-bus';
import { notifySuccess } from '@ocp/notifications';
import { openContent } from '../actions-handlers/open';
import i18nKeys from '../i18n/index';
import { useDeleteContentMutation } from '../mutations/index';
const useActions = (classNameId, classPk, actions) => {
    const { t } = useTranslation();
    const [deleteContent] = useDeleteContentMutation(() => {
        notifySuccess(t(i18nKeys.YOUR_REQUEST_COMPLETED_SUCCESSFULLY));
        eventBus.fire(EventTypes.DeleteContent, { data: { classNameId, classPk } });
    });
    const handleRequest = (item) => {
        if (item.requestType === 'DELETE') {
            deleteContent({
                variables: {
                    classNameId,
                    classPk,
                },
            });
        }
    };
    return actions.filter((action) => KB.isLR || action.linkTarget !== 'POP_UP').map((action) => (Object.assign(Object.assign({}, action), { icon: action.actionType === 'LINK' && action.linkTarget === 'BLANK' ? IconSymbol.Shortcut : undefined, onClick: action.actionType === 'REQUEST' ? () => handleRequest(action) : () => openContent(action) })));
};
export default useActions;
